export interface RentPlan {
  id: string;
  label: string;
  price: string;
  priceNumber: number;
  features: {
    title: string;
    mainBenefit: string;
    details: string;
    example?: {
      title: string;
      items: string[];
    };
    note: string;
    additionalBenefits: string[];
  };
}

export interface PropertyInfo {
  floorPlanId: string;
  area: string;
  station: string;
  walkTime: string;
  units: string;
  floors: string;
  images: string[];
  rentPlans: RentPlan[];
}

export const propertyData: PropertyInfo[] = [
  {
    floorPlanId: '1r',
    area: '東京都 世田谷区\n三軒茶屋駅／東急田園都市線',
    station: '三軒茶屋',
    walkTime: '駅から徒歩6~10分',
    units: '住戸数:30〜40戸',
    floors: '建物階数:8〜12階',
    images: ['surveyarea01.png', 'surveyarea02.png', 'surveyarea03.png'],
    rentPlans: [
      {
        id: 'A',
        label: 'A',
        price: '25万',
        priceNumber: 250000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大15回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　10回/月',
              'ホテル（1泊）　7回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント',
            'バギー・ケージの無料レンタルサービス'
          ]
        }
      },
      {
        id: 'B',
        label: 'B',
        price: '23万',
        priceNumber: 230000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大8回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　5回/月',
              'ホテル（1泊）　4回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント'
          ]
        }
      },
      {
        id: 'C',
        label: 'C',
        price: '21万',
        priceNumber: 210000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大4回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　3回/月',
              'ホテル（1泊）　2回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: []
        }
      }
    ]
  },
  {
    floorPlanId: '1ldk',
    area: '東京都 世田谷区\n三軒茶屋駅／東急田園都市線',
    station: '三軒茶屋',
    walkTime: '駅から徒歩6~10分',
    units: '住戸数:40〜50戸',
    floors: '建物階数:10〜15階',
    images: ['surveyarea01.png', 'surveyarea02.png', 'surveyarea03.png'],
    rentPlans: [
      {
        id: 'A',
        label: 'A',
        price: '34万',
        priceNumber: 340000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大15回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　10回/月',
              'ホテル（1泊）　7回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント',
            'バギー・ケージの無料レンタルサービス'
          ]
        }
      },
      {
        id: 'B',
        label: 'B',
        price: '32万',
        priceNumber: 320000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大8回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　5回/月',
              'ホテル（1泊）　4回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント'
          ]
        }
      },
      {
        id: 'C',
        label: 'C',
        price: '30万',
        priceNumber: 300000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大4回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　3回/月',
              'ホテル（1泊）　2回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: []
        }
      }
    ]
  },
  {
    floorPlanId: '2ldk',
    area: '東京都 世田谷区\n三軒茶屋駅／東急田園都市線',
    station: '三軒茶屋',
    walkTime: '駅から徒歩6~10分',
    units: '住戸数:50〜60戸',
    floors: '建物階数:12〜18階',
    images: ['surveyarea01.png', 'surveyarea02.png', 'surveyarea03.png'],
    rentPlans: [
      {
        id: 'A',
        label: 'A',
        price: '43万',
        priceNumber: 430000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大15回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　10回/月',
              'ホテル（1泊）　7回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント',
            'バギー・ケージの無料レンタルサービス'
          ]
        }
      },
      {
        id: 'B',
        label: 'B',
        price: '41万',
        priceNumber: 410000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大8回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　5回/月',
              'ホテル（1泊）　4回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント'
          ]
        }
      },
      {
        id: 'C',
        label: 'C',
        price: '39万',
        priceNumber: 390000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大4回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　3回/月',
              'ホテル（1泊）　2回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: []
        }
      }
    ]
  }
];

// 妄想マンション02のデータ
export const propertyData2: PropertyInfo[] = [
  {
    floorPlanId: '1r',
    area: '東京都 港区\n表参道駅／銀座線・千代田線・半蔵門線',
    station: '表参道',
    walkTime: '駅から徒歩6~9分',
    units: '住戸数:30〜40戸',
    floors: '建物階数:8〜12階',
    images: ['surveyarea04.png', 'surveyarea05.png', 'surveyarea06.png'],
    rentPlans: [
      {
        id: 'A',
        label: 'A',
        price: '28万',
        priceNumber: 280000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大15回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　10回/月',
              'ホテル（1泊）　7回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント',
            'バギー・ケージの無料レンタルサービス'
          ]
        }
      },
      {
        id: 'B',
        label: 'B',
        price: '26万',
        priceNumber: 260000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大8回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　5回/月',
              'ホテル（1泊）　4回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント'
          ]
        }
      },
      {
        id: 'C',
        label: 'C',
        price: '24万',
        priceNumber: 240000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大4回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　3回/月',
              'ホテル（1泊）　2回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: []
        }
      }
    ]
  },
  {
    floorPlanId: '1ldk',
    area: '東京都 港区\n表参道駅／銀座線・千代田線・半蔵門線',
    station: '表参道',
    walkTime: '駅から徒歩6~9分',
    units: '住戸数:40〜50戸',
    floors: '建物階数:10〜15階',
    images: ['surveyarea04.png', 'surveyarea05.png', 'surveyarea06.png'],
    rentPlans: [
      {
        id: 'A',
        label: 'A',
        price: '39万',
        priceNumber: 390000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大15回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　10回/月',
              'ホテル（1泊）　7回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント',
            'バギー・ケージの無料レンタルサービス'
          ]
        }
      },
      {
        id: 'B',
        label: 'B',
        price: '36万',
        priceNumber: 360000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大8回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　5回/月',
              'ホテル（1泊）　4回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント'
          ]
        }
      },
      {
        id: 'C',
        label: 'C',
        price: '34万',
        priceNumber: 340000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大4回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　3回/月',
              'ホテル（1泊）　2回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: []
        }
      }
    ]
  },
  {
    floorPlanId: '2ldk',
    area: '東京都 港区\n表参道駅／銀座線・千代田線・半蔵門線',
    station: '表参道',
    walkTime: '駅から徒歩6~9分',
    units: '住戸数:50〜60戸',
    floors: '建物階数:12〜18階',
    images: ['surveyarea04.png', 'surveyarea05.png', 'surveyarea06.png'],
    rentPlans: [
      {
        id: 'A',
        label: 'A',
        price: '49万',
        priceNumber: 490000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大15回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　10回/月',
              'ホテル（1泊）　7回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント',
            'バギー・ケージの無料レンタルサービス'
          ]
        }
      },
      {
        id: 'B',
        label: 'B',
        price: '47万',
        priceNumber: 470000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大8回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　5回/月',
              'ホテル（1泊）　4回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: [
            '毎月ペットシーツまたは猫砂プレゼント'
          ]
        }
      },
      {
        id: 'C',
        label: 'C',
        price: '45万',
        priceNumber: 450000,
        features: {
          title: '賃料に含まれる特典一覧',
          mainBenefit: '犬の保育園　最大4回/月 利用可能',
          details: '犬の保育園に限らず\n以下のような組み合わせもできます♪',
          example: {
            title: '例えば…',
            items: [
              'ペットシッティング　3回/月',
              'ホテル（1泊）　2回/月'
            ]
          },
          note: '上記の利用回数以降も、\n入居者限定のお得料金でご利用OK!',
          additionalBenefits: []
        }
      }
    ]
  }
];